import React, { FC } from 'react'

import { IconVCarDongleProps } from './IconVCarDongle.types'
import * as Styled from './styles/IconVCarDongle.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVCarDongle: FC<IconVCarDongleProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVCarDongleProps['size'],
  isResponsive = false,
}: IconVCarDongleProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M35 33.016v5.66A4.331 4.331 0 0 1 30.676 43H17.324A4.331 4.331 0 0 1 13 38.676v-5.66'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M31 39.047H17' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M35.883 33.016H12.234a4.283 4.283 0 0 1-4.347-4.035L7.09 9.386C7 7 8.965 5.016 11.434 5.016h29.652l-.86 23.945a4.28 4.28 0 0 1-4.343 4.055Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVCarDongle
